import { useCallback, useEffect, useMemo, useState } from "react"

import createStore from "@Stores/base-factories"
import { hookPathList, hookCustomFieldsList } from "@Stores/base-factories/store-list"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useDashboardFactory = ({ fetch, siteSelected: { id: siteId } }) => {
  const [item, setItem] = useState(null)

  const reset = useCallback(() => {
    setItem(null)
  }, [])

  useEffect(() => () => reset(), [reset])

  const list = useCallback(async () => {
    const item = await fetch({
      url: 'dashboard',
      params: {
        siteId,
      },
    })

    setItem(item)
    return item
  }, [fetch, siteId])

  const save = useCallback(async payload => {
    await fetch({
      method: 'put',
      url: 'dashboard',
      data: payload,
    })
  }, [fetch])

  return useMemo(() => ({
    item, reset, list,
    useLoad: () => {
      useEffect(() => {
        list()
      }, [])
    },
    useSubmit: () => useCallback(async payload => save(payload), []),
  }), [item, reset, list, save])
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extend(hookPathList())
  .extend(useDashboardFactory)
  .extend(hookCustomFieldsList())
  .factory()

export {
  Provider as DashboardProvider,
  useStore as useDashboardStore,
}
